import React from "react";
import { Link } from "react-router-dom";

const headerTranslations = {
  pt: {
    home: "Início",
    terms: "Termos",
    privacy: "Privacidade",
    about: "Sobre Nós",
  },
  en: {
    home: "Home",
    terms: "Terms",
    privacy: "Privacy",
    about: "About Us",
  },
  es: {
    home: "Inicio",
    terms: "Términos",
    privacy: "Privacidad",
    about: "Sobre Nosotros",
  },
};

export default function Header() {
  const lang = localStorage.getItem("kitoLang") || navigator.language.slice(0, 2);
  const t = headerTranslations[lang] || headerTranslations.pt;

  return (
    <header style={styles.header}>
      <div style={styles.left}>
        <img src="/images/kito.png" alt="Kito App" style={styles.logo} />
        <span style={styles.appName}>Kito App</span>
      </div>

      <div style={styles.right}>
        <nav style={styles.nav}>
          <Link to="/" style={styles.link}>{t.home}</Link>
          <Link to="/termo-de-uso" style={styles.link}>{t.terms}</Link>
          <Link to="/politica-de-privacidade" style={styles.link}>{t.privacy}</Link>
          <Link to="/about" style={styles.link}>{t.about}</Link>
        </nav>

        <div style={styles.flags}>
          <img
            src="https://flagcdn.com/w40/br.png"
            alt="Português"
            style={styles.flag}
            title="Português"
            onClick={() => {
              localStorage.setItem("kitoLang", "pt");
              window.location.reload();
            }}
          />
          <img
            src="https://flagcdn.com/w40/us.png"
            alt="English"
            style={styles.flag}
            title="English"
            onClick={() => {
              localStorage.setItem("kitoLang", "en");
              window.location.reload();
            }}
          />
          <img
            src="https://flagcdn.com/w40/es.png"
            alt="Español"
            style={styles.flag}
            title="Español"
            onClick={() => {
              localStorage.setItem("kitoLang", "es");
              window.location.reload();
            }}
          />
        </div>
      </div>
    </header>
  );
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFF8E1",
    padding: "1rem 1.5rem",
    borderBottom: "1px solid #6D4C41",
    flexWrap: "wrap",
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  logo: {
    height: "32px",
  },
  appName: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#6D4C41",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "1.5rem",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  nav: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
  },
  link: {
    color: "#6D4C41",
    fontSize: "1rem",
    textDecoration: "none",
  },
  flags: {
    display: "flex",
    gap: "0.5rem",
  },
  flag: {
    height: "24px",
    width: "auto",
    borderRadius: "4px",
    cursor: "pointer",
  },
};
